import { ErrorMessage } from 'nhsuk-react-components';

interface CohortRuleErrorMessageProps {
  cohortLabel: string;
}

export default function CohortRuleErrorMessage({ cohortLabel }: CohortRuleErrorMessageProps) {
  return (
    <ErrorMessage
      id={`error-${cohortLabel}`}
      test-id={`error-cohort-${cohortLabel}`}
      aria-label={`Error: Cohort ${cohortLabel} is used in a rule and cannot be deleted`}
    >
      <div>
        <p className="nhsuk-u-margin-top-2 nhsuk-u-font-weight-bold">
          You can&apos;t remove
          {' '}
          {cohortLabel}
          {' '}
          right now because it&apos;s used in one or more rules.
        </p>
        <p className="nhsuk-u-margin-top-2">Edit the affected rules first, then try removing the cohort again.</p>
      </div>
    </ErrorMessage>
  );
}
